import { render, staticRenderFns } from "./CustomerAddressSelect.vue?vue&type=template&id=20d3506c&"
import script from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"
export * from "./CustomerAddressSelect.vue?vue&type=script&lang=js&"
import style0 from "./Address.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports